import {
  EarningMechanismProductPurchaseFragment,
  EarningMechanismTotalSpendOverTimeFragment,
} from '@occc/graphql';

import { SpendBonusFormValues, ProductPurchaseFormValues } from '../types';

export const getProductPurchaseFormValues = (
  earningMechanism: EarningMechanismProductPurchaseFragment,
): ProductPurchaseFormValues => {
  return {
    eligibleProductGroups: earningMechanism.eligibleProductGroups,
    purchaseThreshold: earningMechanism.purchaseThreshold,
    countProductsBy: earningMechanism.countProductsBy,
  };
};

export const getSpendBonusFormValues = (
  earningMechanism: EarningMechanismTotalSpendOverTimeFragment,
): SpendBonusFormValues => {
  return {
    accumulationThreshold: earningMechanism.accumulationThreshold,
    ineligibleProductGroups: earningMechanism.ineligibleProductGroups,
    stayVisibleWhileInProgress: {
      isEnabled: earningMechanism.stayVisibleWhileInProgress ?? false,
    },
  };
};
